import { EbDemande } from './demande';
import { EbUser } from './user';
import { EbEtablissement } from './etablissement';
import { EbParty } from './party';
import { EcCountry } from './country';
import { EbCompagnieCurrency } from './compagnieCurrency';
import { CostCategorie } from './costCategorie';
import { Statique } from '../utils/statique';
import { EbCompagnie } from './compagnie';

export class ExEbDemandeTransporteur {
	exEbDemandeTransporteurNum: number;
	pickupTime: Date;
	deliveryTime: Date;
	transitTime: number;
	price: number;
	comment: string;
	status: number;
	xEbEtablissement: EbEtablissement;
	xEbCompagnie: EbCompagnie;

	leadTimeDeparture: number;
	xEcCountryDeparture: EcCountry;
	cityDeparture: string;

	leadTimeArrival: number;
	xEcCountryArrival: EcCountry;
	cityArrival: string;

	leadTimePickup: number;
	xEcCountryPickup: EcCountry;
	cityPickup: string;

	leadTimeDelivery: number;
	xEcCountryDelivery: EcCountry;
	cityDelivery: string;
	
	leadTimeCustoms: number;
	xEcCountryCustoms: EcCountry;
	cityCustoms: string;

	xEbDemande: EbDemande;
	xTransporteur: EbUser;
	listCostCategorie :  Array<CostCategorie>;
	strListCostCategorie: string;
	xEbCompagnieCurrency : EbCompagnieCurrency;

	xEbUserCt: EbUser;
	xEbUserConfirmBy: EbUser;

	ctCommunity: boolean;

	constructor() {
		this.exEbDemandeTransporteurNum = null;
		this.pickupTime = null;
		this.deliveryTime = null;
		this.price = null;
		this.comment = null;
		this.status = null;
		this.xEbEtablissement = new EbEtablissement();
		this.xEbCompagnie = new EbCompagnie();
		this.leadTimeDeparture = null;
		this.xEcCountryDeparture = new EcCountry();
		this.cityDeparture = null;
		this.leadTimeArrival = null;
		this.xEcCountryArrival = new EcCountry();
		this.cityArrival = null;
		this.leadTimePickup = null;
		this.xEcCountryPickup = new EcCountry();
		this.cityPickup = null;
		this.leadTimeDelivery = null;
		this.xEcCountryDelivery = new EcCountry();
		this.cityDelivery = null;
		this.leadTimeCustoms = null;
		this.xEcCountryCustoms = new EcCountry();
		this.cityCustoms = null;
		this.xEbDemande = null;
		this.xTransporteur = null;
		this.listCostCategorie = new Array<CostCategorie>();
		this.xEbCompagnieCurrency = new EbCompagnieCurrency();
		this.xEbUserCt = null;
		this.xEbUserConfirmBy = null;
		this.strListCostCategorie = null;
		this.ctCommunity = null;
	}

	copy(exEbDemandeTransporteur: ExEbDemandeTransporteur){
		this.exEbDemandeTransporteurNum = exEbDemandeTransporteur.exEbDemandeTransporteurNum;
		this.deliveryTime = exEbDemandeTransporteur.deliveryTime;
		this.pickupTime = exEbDemandeTransporteur.pickupTime;
		this.price = exEbDemandeTransporteur.price;
		this.status = exEbDemandeTransporteur.status;
		this.transitTime = exEbDemandeTransporteur.transitTime;
		this.leadTimeDelivery = exEbDemandeTransporteur.leadTimeDelivery;
		this.leadTimeDeparture = exEbDemandeTransporteur.leadTimeDeparture;
		this.xEcCountryDeparture = exEbDemandeTransporteur.xEcCountryDeparture;
		this.cityDeparture = exEbDemandeTransporteur.cityDeparture;
		
		this.leadTimeArrival = exEbDemandeTransporteur.leadTimeArrival;
		this.xEcCountryArrival = exEbDemandeTransporteur.xEcCountryArrival;
		this.cityArrival = exEbDemandeTransporteur.cityArrival;

		this.leadTimePickup = exEbDemandeTransporteur.leadTimePickup;
		this.xEcCountryPickup = exEbDemandeTransporteur.xEcCountryPickup;
		this.cityPickup = exEbDemandeTransporteur.cityPickup;
		
		this.xEcCountryDelivery = exEbDemandeTransporteur.xEcCountryDelivery;
		this.cityDelivery = exEbDemandeTransporteur.cityDelivery;
		
		this.leadTimeCustoms = exEbDemandeTransporteur.leadTimeCustoms;
		this.xEcCountryCustoms = exEbDemandeTransporteur.xEcCountryCustoms;
		this.cityCustoms = exEbDemandeTransporteur.cityCustoms;
		
		this.strListCostCategorie = exEbDemandeTransporteur.strListCostCategorie;
		
		this.ctCommunity = exEbDemandeTransporteur.ctCommunity;
		
		if(exEbDemandeTransporteur.xEbEtablissement){
			this.xEbEtablissement = new EbEtablissement();
			this.xEbEtablissement.ebEtablissementNum = exEbDemandeTransporteur.xEbEtablissement.ebEtablissementNum;
		}
		
		if(exEbDemandeTransporteur.xEbCompagnie){
			this.xEbCompagnie = new EbCompagnie();
			this.xEbCompagnie.ebCompagnieNum = exEbDemandeTransporteur.xEbCompagnie.ebCompagnieNum;
		}
		
		if(exEbDemandeTransporteur.xTransporteur){
			this.xTransporteur = new EbUser();
			this.xTransporteur.ebUserNum = exEbDemandeTransporteur.xTransporteur.ebUserNum;
		}
		
		if(exEbDemandeTransporteur && exEbDemandeTransporteur.xEbDemande){
			this.xEbDemande = new EbDemande();
			this.xEbDemande.ebDemandeNum = exEbDemandeTransporteur.xEbDemande.ebDemandeNum;
		}

		if(exEbDemandeTransporteur.xEbCompagnieCurrency != null)
		{
			this.xEbCompagnieCurrency = Statique.cloneObject(exEbDemandeTransporteur.xEbCompagnieCurrency);
		}

		if(exEbDemandeTransporteur.listCostCategorie != null)
			this.listCostCategorie = exEbDemandeTransporteur.listCostCategorie;
		
		if(exEbDemandeTransporteur.xEbUserCt){
			this.xEbUserCt = new EbUser();
			this.xEbUserCt.ebUserNum = exEbDemandeTransporteur.xEbUserCt.ebUserNum;
		}
		
		if(exEbDemandeTransporteur.xEbUserConfirmBy){
			this.xEbUserConfirmBy = new EbUser();
			this.xEbUserConfirmBy.ebUserNum = exEbDemandeTransporteur.xEbUserConfirmBy.ebUserNum;
		}
	}

	copyData(exEbDemandeTransporteur: ExEbDemandeTransporteur){
		this.deliveryTime = exEbDemandeTransporteur.deliveryTime;
		this.pickupTime = exEbDemandeTransporteur.pickupTime;
		this.price = exEbDemandeTransporteur.price;
		this.status = exEbDemandeTransporteur.status;
		this.transitTime = exEbDemandeTransporteur.transitTime;
		this.leadTimeDelivery = exEbDemandeTransporteur.leadTimeDelivery;
		this.leadTimeDeparture = exEbDemandeTransporteur.leadTimeDeparture;
		this.xEcCountryDeparture = exEbDemandeTransporteur.xEcCountryDeparture;
		this.cityDeparture = exEbDemandeTransporteur.cityDeparture;
		
		this.leadTimeArrival = exEbDemandeTransporteur.leadTimeArrival;
		this.xEcCountryArrival = exEbDemandeTransporteur.xEcCountryArrival;
		this.cityArrival = exEbDemandeTransporteur.cityArrival;

		this.leadTimePickup = exEbDemandeTransporteur.leadTimePickup;
		this.xEcCountryPickup = exEbDemandeTransporteur.xEcCountryPickup;
		this.cityPickup = exEbDemandeTransporteur.cityPickup;
		
		this.xEcCountryDelivery = exEbDemandeTransporteur.xEcCountryDelivery;
		this.cityDelivery = exEbDemandeTransporteur.cityDelivery;
		
		this.leadTimeCustoms = exEbDemandeTransporteur.leadTimeCustoms;
		this.xEcCountryCustoms = exEbDemandeTransporteur.xEcCountryCustoms;
		this.cityCustoms = exEbDemandeTransporteur.cityCustoms;
		
		this.strListCostCategorie = exEbDemandeTransporteur.strListCostCategorie;
		
		if(exEbDemandeTransporteur.xEbCompagnieCurrency != null)
		{
			this.xEbCompagnieCurrency = Statique.cloneObject(exEbDemandeTransporteur.xEbCompagnieCurrency);
		}

		if(exEbDemandeTransporteur.listCostCategorie != null)
			this.listCostCategorie = exEbDemandeTransporteur.listCostCategorie;
		
	}
}



// WEBPACK FOOTER //
// ./src/app/classes/demandeTransporteur.ts